import * as O from 'fp-ts/lib/Option';
import {pipe} from 'fp-ts/lib/pipeable';
import React, {ComponentType} from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {getUserClaims} from 'Shared/utilities/UserProfileUtilities';
import {AgentAgencyClaim} from 'Users/models/AgentAgencyClaim';
import {UserTypeClaimKey} from 'Users/models/Claims';
import {hasUserTypeClaimKey} from 'Users/selectors/userProfileSelectors';

export type WithSelectedAgencyProps = {
  selectedAgency: AgentAgencyClaim;
};

const withSelectedAgency = <TProps extends {}>(
  WrappedComponent: ComponentType<TProps & WithSelectedAgencyProps>
): ComponentType<Omit<TProps, keyof WithSelectedAgencyProps>> => {
  const Component = (props: any) => {
    const {selectedAgency} = useSelector((state: ReducerState) => {
      return state.user.profile;
    });

    let [isAgent] = [false];

    const userClaims = getUserClaims();

    return pipe(
      selectedAgency,
      O.fold(
        () => {
          if (O.isSome(userClaims)) {
            isAgent = hasUserTypeClaimKey(userClaims.value, UserTypeClaimKey.AgentSite);
          }

          if (!isAgent) {
            return <WrappedComponent {...(props as any)} />;
          } else {
            return <>Selected Agency Is Missing, Unable To Render</>;
          }
        },
        agency => <WrappedComponent {...(props as any)} selectedAgency={agency} />
      )
    );
  };

  return (props: Omit<TProps, keyof WithSelectedAgencyProps>) => <Component {...props} />;
};

export default withSelectedAgency;
